var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-tab',{attrs:{"page-scroller":".router-tab__container","tabs":[
    '/page-scroller/page/1',
    '/page-scroller/scroll-position',
    '/page-scroller/scroll-multi',
    '/page-scroller/scroll-async'
  ]}})}
var staticRenderFns = []

export { render, staticRenderFns }